import { createForm } from "../../forms";
import { cents } from "../../../utils";

import { directDepositValidationSchema } from "./schema";

import type { DirectDepositManualForm } from "./types";

const initialValues: DirectDepositManualForm = {
  accountId: "" as API.AccountId,
  employer: "",
  allocationMethod: "whole",
  valuePercent: "100" as unknown as number,
  valueCents: cents(0),
};

export const directDepositEnrollmentForm = createForm<DirectDepositManualForm>({
  initialValues,
  translateValidationSchema: directDepositValidationSchema,
});
